import React, { createContext, useEffect, useState } from "react";

// Create the context
export const MyContext = createContext();

// Create a provider component
export const MyProvider = ({ children }) => {
  // Define the state or any value you want to share
  const [pswd, setPswd] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [onboardToken, setOnboardToken] = useState({});
  const [userId, setUserId] = useState("");
  const [selectedOption, setSelectedOption] = useState({
    projectId: -1,
    projectName: "",
  });
  const [roleType, setRoleType] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [workerDetails, setWorkerDetails] = useState(null);
  const [markAttendanceVisible, setMarkAttendanceVisible] = useState(false);

  useEffect(() => {
    const id = localStorage.getItem("userId");
    if (id && window.location.pathname.replace(/\/$/, "") === "") {
      window.location.href = "/task-page";
    } else if (!id && window.location.pathname.replace(/\/$/, "") === "") {
      window.location.href = "/login";
    }
  }, [window.location.pathname]);

  useEffect(() => {
    document.title = "OkayGo - Task Execution";
    if (window.location.pathname.replace(/\/$/, "") === "/mark-attendance") {
      document.title = "OkayGo - Attendance Flow";
      return;
    }
  }, [markAttendanceVisible]);

  useEffect(() => {
    const id = localStorage.getItem("userId");
    setUserId(id);
    if (!id && window.location.pathname.replace(/\/$/, "") !== "/login") {
      localStorage.clear();
      window.location.href = "/login";
    }
  }, []);

  return (
    <MyContext.Provider
      value={{
        pswd,
        setPswd,
        mobileNumber,
        setMobileNumber,
        onboardToken,
        setOnboardToken,
        selectedOption,
        setSelectedOption,
        loading,
        setLoading,
        roleType,
        setRoleType,
        userId,
        isNavbarVisible,
        setIsNavbarVisible,
        workerDetails,
        setWorkerDetails,
        setMarkAttendanceVisible,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
